
import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import Scroll from 'better-scroll';
import {
  Menu,
  Submenu,
  MenuItem,
} from 'element-ui';
import { IUSERSTATE, IAPPSTATE } from '@/store/state.d';

@Component({
  components: {
    Menu,
    Submenu,
    MenuItem,
  },
})
export default class TMenu extends Vue {
  @State user!: IUSERSTATE;

  @State app!: IAPPSTATE;

  public $refs!: {
    menu: HTMLElement,
  }

  routeGo(path: string) {
    this.$router.push(path);
  }

  get getMenus() {
    return (this.user.stairMenus[0].children || []).filter((item: any) => item.meta.menu);
  }

  mounted() {
    /* eslint-disable no-new */
    new Scroll(this.$refs.menu, {
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300,
      },
    });
  }
}
